// SignupButton.jsx

import React from 'react';

// CSS
import './SignupButton.css';

/**
 * SignupButton
 *
 * Button component for user signup.
 *
 * @param {boolean} [disabled] - When true, fades the button and blocks activation.
 * @param {object} image - The image source for the button icon.
 * @param {string} label - The text label for the button.
 * @param {Function} [onClick] - Click handler when enabled.
 *
 * @returns {ReactNode} - SignupButton.
 */
const SignupButton = React.memo(({ disabled = false, image, label, onClick }) => {

    // ----- RENDER ----- //

    return (

        <div
          aria-disabled={disabled}
          className={`signup-button-container${disabled ? ' signup-button-disabled' : ''}`}
          role="button"
          tabIndex={disabled ? -1 : 0}
          onClick={disabled ? undefined : onClick}
          onKeyDown={(e) => {
                if (disabled || !onClick) return;
                if (e.key === 'Enter' || e.key === ' ') onClick(e);
            }}
        >

            {/* HERO LOGIN BUTTON */}
            <div
              className="signup-button-icon"
            >

                {/* HERO LOGIN BUTTON ICON IMAGE */}
                <img
                  className="signup-button-icon-image"
                  src={image}
                  alt={label}
                />

            </div>

            {/* HERO LOGIN BUTTON */}
            <div
              className="signup-button-text"
            >
                {label}
            </div>

        </div>
    );

});

// Dev Tools
SignupButton.displayName = 'SignupButton';

export default SignupButton;
